import {i18n} from 'src/shared/config'

export const translations = {
  title: i18n(
    'banner.title.door-to-door',
    'Доставка от двери до двери доступна только в кабинете для бизнеса',
  ),
  description: i18n('banner.description.door-to-door', {fallBackToKey: false}),
  list: i18n('banner.list.door-to-door', {fallBackToKey: false}),
  imageSrc: i18n('banner.image-src.door-to-door', {fallBackToKey: false}),
}
